import React, { useEffect } from 'react';
import './Header.css'; // Importa el archivo CSS para estilos
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth, logout } from '../context/AuthContext';

const HeaderLogged = () => {
  const { logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };


  const handleLogout = () => {
    logout();
    navigate('/login');
  }

  return (
    <header className="header">
      <nav className="navbar navbar-expand-md fixed-top navbar-light bg-white">
        <div className="container-fluid">
          <button className="col-12 border border-dark mt-1 mb-1 navbar-toggler order-2 order-md-1" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>

          <a className="navbar-brand order-1 order-md-3">
            <img src="./Logos-color-avianca.png" className='mx-3 img-fluid' alt="logo" />
          </a>

          <div div className="offcanvas offcanvas-end order-4 order-md-4" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
            <div className="offcanvas-header navbar navbar-expand-md fixed-top navbar-light bg-transparent mx-2 d-flex justify-content-between align-items-center">
              <button type="button" className="navbar-toggler btn-close text-white bg-white mb-2" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            {/* Offcanvas content */}
            <div className="external-container offcanvas-body order-4 order-md-4 d-block d-md-none d-lg-none d-xl-none mr-3">
              <ul className="navbar-nav ms-auto mt-5">
                <li className="form-container-button text-center border border-dark mt-5">
                  <Link to="/crear-evento" className={`nav-link Bebas-Neue text-dark ${isActive('/crear-evento')}`}>crear evento</Link>
                </li>
                <li className='form-container-button text-center border border-dark'>
                  <Link to="/events" className={`nav-link Bebas-Neue text-red ${isActive('/events')}`}>ver eventos</Link>
                </li>
                <li className="form-container-button text-center border border-dark">
                  <Link to="/agregarPuntos" className={`nav-link Bebas-Neue text-dark ${isActive('/agregarPuntos')}`}>añadir puntos</Link>
                </li>

                <li className="form-container-button text-center border border-dark">
                  <div onClick={handleLogout} className="nav-link text-dark Bebas-Neue text-items-nav btn btn-link">
                    logout
                  </div>
                </li>
              </ul>
            </div>

            {/* Navbar content for larger screens */}
            <div className="offcanvas-body order-4 order-md-4 d-none d-md-flex d-lg-flex d-xl-flex mr-3">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item items-menu-mobile">
                  <Link to="/crear-evento" className={`nav-link text-dark Bebas-Neue text-items-nav ${isActive('/crear-evento')}`}>crear evento</Link>
                </li>
                <li className="nav-item items-menu-mobile">
                  <Link to="/events" className={`nav-link text-dark Bebas-Neue text-items-nav ${isActive('/events')}`}>ver eventos</Link>
                </li>

                <li className="nav-item items-menu-mobile">
                  <Link to="/agregarPuntos" className={`nav-link text-dark Bebas-Neue text-items-nav ${isActive('/eventos')}`}>añadir puntos</Link>
                </li>

                <li className="nav-item items-menu-mobile">
                  <div onClick={handleLogout} className="nav-link text-dark Bebas-Neue text-items-nav btn btn-link">
                    logout
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

const HeaderNotLogged = () => (
  <header className="header">
    <nav className="navbar navbar-expand-md fixed-top navbar-light bg-transparent">
      <div className="container-fluid d-flex justify-content-end align-items-center">
        <a className="navbar-brand order-3">
          {/* <img src="./aviancaLogo.png" width={"60px"} className="mx-3 img-fluid" alt="logo" /> */}
        </a>
      </div>
    </nav>
  </header>
);

const Header = () => {
  const { token } = useAuth();

  useEffect(() => {
    // Aquí podrías añadir lógica adicional si necesitas algún efecto secundario
  }, [token]);

  // Renderizado condicional del header dependiendo del token
  return token ? <HeaderLogged /> : <HeaderNotLogged />;
};

export default Header;